"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAppleAuthTokenResponseSchema = exports.ListOrganisationIdResponseSchema = exports.OrganisationIdParamsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const common_1 = require("../common");
/**
 * Parameters
 */
exports.OrganisationIdParamsSchema = (0, core_1.StrictObject)({
    ref: typebox_1.Type.String(),
}, {
    title: "Organisation Id",
});
/**
 * Responses
 */
exports.ListOrganisationIdResponseSchema = typebox_1.Type.Array(typebox_1.Type.String(), {
    title: "Organisation Id list",
});
exports.GetAppleAuthTokenResponseSchema = (0, core_1.StrictObject)(common_1.AppleAuthTokenFields, {
    title: "Apple Auth token",
    description: "A token that can be used with the Apple Search Ads API",
});
